import api from '@/api'
import { HTTP_STATUS, maximoIncendiosCache, valoresIncendioFinalizado } from '@/helpers/constants'
import { rangoPorDefectoIncendios } from '@/helpers/incendios'
import socket from '@/plugins/socket'
import Vue from 'vue'
import DateService from '@/helpers/DateServiceOld'
import UUIDService from '@/helpers/UUIDService'

const Q = require('q')

const state = {
  incendiosReduced: [],
  incendioById: {},
  incendioLoading: {},
  incendioCacheOrder: [],
  filtro: rangoPorDefectoIncendios,
  tiposIncendioEstado: [],
  tiposIncendioNivel: [],
  tiposDeteccion: [],
  imagenesSatelite: []
}

const getters = {
  incendiosReduced: (state) => state.incendiosReduced,

  incendiosReducedFiltered: (state) => {
    const data = state.incendiosReduced || []
    let [ini, fin] = state.filtro || []
    if (!(ini instanceof Date) || !(fin instanceof Date)) return data
    if (ini > fin) [ini, fin] = [fin, ini]

    return data.filter(inc => {
      const fechaItem = new Date(inc.FECHA_CREACION)
      const isFinalizado = (inc?.ESTADOS || []).some(
        e => valoresIncendioFinalizado.includes(e?.TIPO_INCENDIO_ESTADO?.VALUE)
      )
      return !isFinalizado || (fechaItem >= ini && fechaItem <= fin)
    })
  },

  filtro: (state) => state.filtro,

  getIncendioByID: (state) => (id) => state.incendioById[id] || null,

  isIncendioLoading: (state) => (id) => !!state.incendioLoading[id],

  isIncendioFinalizado: (state) => (id) => {
    const inc = state.incendioById[id] || state.incendiosReduced.find(x => x.ID_INCENDIO?.equalsIgnoreCase?.(id))
    const estados = inc?.ESTADOS || []
    return estados.some(e => valoresIncendioFinalizado.includes(e?.TIPO_INCENDIO_ESTADO?.VALUE))
  },

  tiposIncendioEstado: (state) => state.tiposIncendioEstado,

  tiposIncendioNivel: (state) => state.tiposIncendioNivel,

  getTipoIncendioEstadoByValue: (state) => (value) =>
    state.tiposIncendioEstado.find(x => x.VALUE === value),

  tiposDeteccion: (state) => state.tiposDeteccion,

  getTipoDeteccionById: (state) => (idTipoDeteccion) => {
    if (!idTipoDeteccion) return null
    return state.tiposDeteccion.find(x => x.ID_TIPO_DETECCION === idTipoDeteccion) || null
  },

  imagenesSatelite: (state) => state.imagenesSatelite
}

const mutations = {
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },

  SET_INCENDIOS_REDUCED(state, incendios) {
    state.incendiosReduced = incendios
  },

  OCULTAR_INCENDIO(state, data) {
    const idx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (idx !== -1) {
      Vue.set(state.incendiosReduced, idx, { ...state.incendiosReduced[idx], OCULTO: data.OCULTO })
      if (data.OCULTO) state.incendiosReduced.splice(idx, 1)
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      state.incendioById = {
        ...state.incendioById,
        [data.ID_INCENDIO]: { ...state.incendioById[data.ID_INCENDIO], OCULTO: data.OCULTO }
      }
    }
  },

  SET_INCENDIO_LOADING(state, { id, value }) {
    state.incendioLoading = { ...state.incendioLoading, [id]: value }
  },

  SET_INCENDIO_BY_ID(state, inc) {
    if (!inc || !inc.ID_INCENDIO) return
    const id = inc.ID_INCENDIO

    state.incendioById = { ...state.incendioById, [id]: inc }

    state.incendioCacheOrder = state.incendioCacheOrder.filter(x => x !== id)
    state.incendioCacheOrder.push(id)

    if (state.incendioCacheOrder.length > maximoIncendiosCache) {
      const evictId = state.incendioCacheOrder.shift()
      if (evictId) {
        const { [evictId]: _drop1, ...rest } = state.incendioById
        state.incendioById = rest
        const { [evictId]: _drop2, ...restFlags } = state.incendioLoading
        state.incendioLoading = restFlags
      }
    }
  },

  SET_TIPOS_INCENDIO_ESTADO(state, tiposIncendioEstado) {
    state.tiposIncendioEstado = tiposIncendioEstado
  },
  SET_TIPOS_INCENDIO_NIVEL(state, tiposIncendioNivel) {
    state.tiposIncendioNivel = tiposIncendioNivel
  },
  SET_TIPOS_DETECCION(state, tiposDeteccion) {
    state.tiposDeteccion = tiposDeteccion
  },
  SET_IMAGENES_SATELITE(state, imagenesSatelite) {
    state.imagenesSatelite = imagenesSatelite
  },

  SOCKET_syncIncendioDetalle(state, inc) {
    if (!inc?.ID_INCENDIO) return
    if (state.incendioById[inc.ID_INCENDIO]) {
      state.incendioById = { ...state.incendioById, [inc.ID_INCENDIO]: inc }
    }
  },

  SOCKET_addIncendio(state, data) {
    state.incendiosReduced.unshift({
      ...data,
      ESTADOS: data.ESTADOS || [],
      NIVELES: data.NIVELES || []
    })
    this.notify('Nuevo incendio', `Se ha iniciado un incendio en ${data.LOCALIDAD}`)
  },

  SOCKET_changeIncendio(state, data) {
    const idx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (idx !== -1) {
      const prev = state.incendiosReduced[idx]
      Vue.set(state.incendiosReduced, idx, {
        ...prev,
        NOMBRE: data.NOMBRE,
        MUNICIPIO: data.MUNICIPIO,
        LOCALIDAD: data.LOCALIDAD,
        LATITUD: data.LATITUD,
        LONGITUD: data.LONGITUD,
        ID_TIPO_DETECCION: data.ID_TIPO_DETECCION,
        OBSERVACIONES: data.OBSERVACIONES
      })
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      state.incendioById = {
        ...state.incendioById,
        [data.ID_INCENDIO]: {
          ...state.incendioById[data.ID_INCENDIO],
          NOMBRE: data.NOMBRE,
          MUNICIPIO: data.MUNICIPIO,
          LOCALIDAD: data.LOCALIDAD,
          LATITUD: data.LATITUD,
          LONGITUD: data.LONGITUD,
          ID_TIPO_DETECCION: data.ID_TIPO_DETECCION,
          OBSERVACIONES: data.OBSERVACIONES
        }
      }
    }
    this.notify(`Incendio ${data.LOCALIDAD}`, 'Se han actualizado los datos')
  },

  SOCKET_addNivelIncendio(state, data) {
    const idx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (idx !== -1) {
      const inc = { ...state.incendiosReduced[idx] }
      inc.NIVELES = [data, ...(inc.NIVELES || [])]
      Vue.set(state.incendiosReduced, idx, inc)
      this.notify(`Incendio ${inc.LOCALIDAD}`, `Pasa a ${data.TIPO_INCENDIO_NIVEL?.INCENDIO_NIVEL}`)
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      const inc = { ...state.incendioById[data.ID_INCENDIO] }
      inc.NIVELES = [data, ...(inc.NIVELES || [])]
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: inc }
    }
  },

  SOCKET_deleteNivelIncendio(state, data) {
    const idx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (idx !== -1) {
      const inc = { ...state.incendiosReduced[idx] }
      inc.NIVELES = Array.isArray(inc.NIVELES) ? inc.NIVELES.slice(1) : []
      Vue.set(state.incendiosReduced, idx, inc)
      this.notify(`Incendio ${inc.LOCALIDAD}`, inc.NIVELES.length === 0 ? 'se elimina el nivel' : `Pasa a ${inc.NIVELES[0].TIPO_INCENDIO_NIVEL?.INCENDIO_NIVEL}`)
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      const inc = { ...state.incendioById[data.ID_INCENDIO] }
      inc.NIVELES = Array.isArray(inc.NIVELES) ? inc.NIVELES.slice(1) : []
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: inc }
    }
  },

  SOCKET_editNivelIncendio(state, data) {
    const touch = inc => {
      if (!Array.isArray(inc?.NIVELES)) return inc
      const i = inc.NIVELES.findIndex(n => n.ID_INCENDIO_NIVEL?.equalsIgnoreCase?.(data.ID_INCENDIO_NIVEL))
      if (i !== -1) {
        const copy = { ...inc }
        copy.NIVELES = [...inc.NIVELES]
        copy.NIVELES[i] = {
          ...copy.NIVELES[i],
          FECHA_INICIO: data.dataEstado.FECHA_INICIO,
          FECHA_FIN: data.dataEstado.FECHA_FIN
        }
        return copy
      }
      return inc
    }
    const ridx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.dataEstado.ID_INCENDIO))
    if (ridx !== -1) Vue.set(state.incendiosReduced, ridx, touch(state.incendiosReduced[ridx]))
    const id = data.dataEstado.ID_INCENDIO
    if (state.incendioById[id]) state.incendioById = { ...state.incendioById, [id]: touch(state.incendioById[id]) }
  },

  SOCKET_addEstadoIncendio(state, data) {
    const idx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (idx !== -1) {
      const inc = { ...state.incendiosReduced[idx] }
      inc.ESTADOS = [data, ...(inc.ESTADOS || [])]
      if (data.CODIGO_TIPO_ESTADO === 0 && data.FECHA) inc.FECHA_CREACION = data.FECHA
      Vue.set(state.incendiosReduced, idx, inc)
      this.notify(`Incendio ${inc.LOCALIDAD}`, `Pasa a estado ${data.TIPO_INCENDIO_ESTADO?.INCENDIO_ESTADO}`)
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      const inc = { ...state.incendioById[data.ID_INCENDIO] }
      inc.ESTADOS = [data, ...(inc.ESTADOS || [])]
      if (data.CODIGO_TIPO_ESTADO === 0 && data.FECHA) inc.FECHA_CREACION = data.FECHA
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: inc }
    }
  },

  SOCKET_editEstadoIncendio(state, data) {
    const touch = inc => {
      if (!Array.isArray(inc?.ESTADOS)) return inc
      const i = inc.ESTADOS.findIndex(e => e.ID_TIPO_INCENDIO_ESTADO?.equalsIgnoreCase?.(data.ID_TIPO_INCENDIO_ESTADO))
      if (i !== -1) {
        const copy = { ...inc }
        copy.ESTADOS = [...inc.ESTADOS]
        copy.ESTADOS[i] = { ...copy.ESTADOS[i], FECHA: data.FECHA }
        if (data.CODIGO_TIPO_ESTADO === 0 && data.FECHA) copy.FECHA_CREACION = data.FECHA
        return copy
      }
      return inc
    }
    const ridx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (ridx !== -1) Vue.set(state.incendiosReduced, ridx, touch(state.incendiosReduced[ridx]))
    if (state.incendioById[data.ID_INCENDIO]) {
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: touch(state.incendioById[data.ID_INCENDIO]) }
    }
  },

  SOCKET_deleteEstadoIncendio(state, data) {
    const ridx = state.incendiosReduced.findIndex(x => x.ID_INCENDIO?.equalsIgnoreCase?.(data.ID_INCENDIO))
    if (ridx !== -1) {
      const inc = { ...state.incendiosReduced[ridx] }
      if (Array.isArray(inc.ESTADOS) && inc.ESTADOS.length > 0) inc.ESTADOS = inc.ESTADOS.slice(1)
      Vue.set(state.incendiosReduced, ridx, inc)
      if (inc.ESTADOS?.[0]) {
        this.notify(`Incendio ${inc.LOCALIDAD}`, `Pasa a estado ${inc.ESTADOS[0].TIPO_INCENDIO_ESTADO?.INCENDIO_ESTADO}`)
      }
    }
    if (state.incendioById[data.ID_INCENDIO]) {
      const inc = { ...state.incendioById[data.ID_INCENDIO] }
      if (Array.isArray(inc.ESTADOS) && inc.ESTADOS.length > 0) inc.ESTADOS = inc.ESTADOS.slice(1)
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: inc }
    }
  },

  SOCKET_changeSectoresIncendio(state, data) {
    if (state.incendioById[data.ID_INCENDIO]) {
      const inc = { ...state.incendioById[data.ID_INCENDIO], SECTORES: data.SECTORES }
      state.incendioById = { ...state.incendioById, [data.ID_INCENDIO]: inc }
      this.notify(`Incendio ${inc.LOCALIDAD}`, 'Sectores actualizados')
    }
  },

  SOCKET_addMediosIncendio(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return

    const inc = { ...state.incendioById[id] }
    const iSector = inc.SECTORES?.findIndex(s => s.ID_SECTOR?.equalsIgnoreCase?.(data.ID_SECTOR)) ?? -1
    if (iSector === -1) return

    const sectores = [...inc.SECTORES]
    const sector = { ...sectores[iSector], MEDIOS: Array.isArray(sectores[iSector].MEDIOS) ? [...sectores[iSector].MEDIOS] : [] }

    const mediosMsg = []
    for (const medioAdd of data.MEDIOS) {
      sector.MEDIOS.push(medioAdd)

      let newEstado = 24
      if (medioAdd.FECHA_ALARMADO) newEstado = 7
      if (medioAdd.FECHA_EN_CAMINO) newEstado = 1
      if (medioAdd.FECHA_EN_LUGAR) newEstado = 19
      if (medioAdd.FECHA_FINALIZADO) newEstado = 24

      const medio = this.getters['medio/getMedioByID'](medioAdd.ID_MEDIO)
      if (medio) {
        medio.ESTADO = newEstado
        medio.ID_INCENDIO = inc.ID_INCENDIO
        mediosMsg.push(medio.MEDIO)
      }
    }

    sectores[iSector] = sector
    inc.SECTORES = sectores
    state.incendioById = { ...state.incendioById, [id]: inc }
    this.notify(`Incendio ${inc.LOCALIDAD}`, `Medios [${mediosMsg.join(', ')}] asignados`)
  },

  SOCKET_editMedioIncendio(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return

    const inc = { ...state.incendioById[id] }
    const sectores = Array.isArray(inc.SECTORES) ? inc.SECTORES.map(s => ({ ...s, MEDIOS: Array.isArray(s.MEDIOS) ? [...s.MEDIOS] : [] })) : []

    for (const s of sectores) {
      const idx = s.MEDIOS.findIndex(m => m.ID_MEDIO_SECTOR?.equalsIgnoreCase?.(data.ID_MEDIO_SECTOR))
      if (idx !== -1) s.MEDIOS.splice(idx, 1)
    }
    const sNew = sectores.find(x => x.ID_SECTOR?.equalsIgnoreCase?.(data.ID_SECTOR))
    if (sNew) {
      const medioData = { ...data }
      if (Array.isArray(medioData.FECHAS_MODIFICADAS) && medioData.FECHAS_MODIFICADAS.length) {
        const origenActualizado = { ...(medioData.FECHAS_ORIGEN || {}) }
        for (const field of medioData.FECHAS_MODIFICADAS) {
          origenActualizado[field] = 'WEB'
        }
        medioData.FECHAS_ORIGEN = origenActualizado
      }
      sNew.MEDIOS.push(medioData)
    }

    const medio = this.getters['medio/getMedioByID'](data.ID_MEDIO)
    if (medio) {
      medio.ESTADO = data.ESTADO
      medio.ID_INCENDIO = data.ID_INCENDIO
    }

    inc.SECTORES = sectores
    state.incendioById = { ...state.incendioById, [id]: inc }
  },

  SOCKET_deleteMedioIncendio(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return

    const inc = { ...state.incendioById[id] }
    const sectores = Array.isArray(inc.SECTORES) ? inc.SECTORES.map(s => ({ ...s, MEDIOS: Array.isArray(s.MEDIOS) ? [...s.MEDIOS] : [] })) : []
    const s = sectores.find(x => x.ID_SECTOR?.equalsIgnoreCase?.(data.ID_SECTOR))
    if (!s) return

    const pos = s.MEDIOS.findIndex(m => m.ID_MEDIO_SECTOR?.equalsIgnoreCase?.(data.ID_MEDIO_SECTOR))
    if (pos !== -1) s.MEDIOS.splice(pos, 1)

    if (data.IS_ACTUALIZAR_ESTADO) {
      const medio = this.getters['medio/getMedioByID'](data.ID_MEDIO)
      if (medio) {
        medio.ESTADO = 24
        medio.ID_INCENDIO = null
      }
    }

    inc.SECTORES = sectores
    state.incendioById = { ...state.incendioById, [id]: inc }
    this.notify(`Incendio ${inc.LOCALIDAD}`, 'El medio se ha eliminado')
  },

  SOCKET_editPlanificacionMedio(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return

    const inc = { ...state.incendioById[id] }
    const sectores = Array.isArray(inc.SECTORES) ? inc.SECTORES.map(s => ({ ...s, MEDIOS: Array.isArray(s.MEDIOS) ? [...s.MEDIOS] : [] })) : []

    for (const sector of sectores) {
      const idx = sector.MEDIOS.findIndex(m => m.ID_MEDIO_SECTOR?.equalsIgnoreCase?.(data.PLANIFICACION.ID_MEDIO_SECTOR))
      if (idx !== -1) {
        const medioActual = { ...(sector.MEDIOS[idx] || {}) }
        const medioNuevo = { ...medioActual, PLANIFICACION: data.PLANIFICACION }
        Vue.set(sector.MEDIOS, idx, medioNuevo)
      }
    }

    inc.SECTORES = sectores
    state.incendioById = { ...state.incendioById, [id]: inc }
  },

  SOCKET_addPlanOperaciones(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    inc.PLANES_OPERACIONES = [data, ...(inc.PLANES_OPERACIONES || [])]
    state.incendioById = { ...state.incendioById, [id]: inc }
    this.notify('Nuevo plan de operaciones', `Se ha creado un plan de operaciones para el incendio en ${inc.LOCALIDAD}`)
  },

  SOCKET_editPlanOperaciones(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    const i = (inc.PLANES_OPERACIONES || []).findIndex(p => p.ID_PLAN_OPERACIONES?.equalsIgnoreCase?.(data.ID_PLAN_OPERACIONES))
    if (i !== -1) {
      inc.PLANES_OPERACIONES = [...inc.PLANES_OPERACIONES]
      inc.PLANES_OPERACIONES[i] = data
      state.incendioById = { ...state.incendioById, [id]: inc }
      this.notify('Plan de operaciones modificado', `Se ha modificado un plan de operaciones para el incendio en ${inc.LOCALIDAD}`)
    }
  },

  SOCKET_deletePlanOperaciones(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    const i = (inc.PLANES_OPERACIONES || []).findIndex(p => p.ID_PLAN_OPERACIONES?.equalsIgnoreCase?.(data.ID_PLAN_OPERACIONES))
    if (i !== -1) {
      inc.PLANES_OPERACIONES.splice(i, 1)
      state.incendioById = { ...state.incendioById, [id]: inc }
      this.notify('Plan de operaciones eliminado', `Se ha eliminado un plan de operaciones para el incendio en ${inc.LOCALIDAD}`)
    }
  },

  SOCKET_addPerimetro(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    inc.PERIMETRO = [data, ...(inc.PERIMETRO || [])]
    state.incendioById = { ...state.incendioById, [id]: inc }
    this.notify('Nuevo perímetro', `Se ha creado un perímetro para el incendio en ${inc.LOCALIDAD}`)
  },

  SOCKET_editPerimetro(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    const i = (inc.PERIMETRO || []).findIndex(p => p.ID_PERIMETRO?.equalsIgnoreCase?.(data.ID_PERIMETRO))
    if (i !== -1) {
      inc.PERIMETRO = [...inc.PERIMETRO]
      inc.PERIMETRO[i] = { ...inc.PERIMETRO[i], GRAFICOS_PERIMETRO: data.GRAFICOS_PERIMETRO }
      state.incendioById = { ...state.incendioById, [id]: inc }
      this.notify('Perímetro modificado', `Se ha modificado un perímetro para el incendio en ${inc.LOCALIDAD}`)
    }
  },

  SOCKET_deletePerimetro(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    const i = (inc.PERIMETRO || []).findIndex(p => p.ID_PERIMETRO?.equalsIgnoreCase?.(data.ID_PERIMETRO))
    if (i !== -1) {
      inc.PERIMETRO.splice(i, 1)
      state.incendioById = { ...state.incendioById, [id]: inc }
      this.notify('Perímetro eliminado', `Se ha eliminado un perímetro para el incendio en ${inc.LOCALIDAD}`)
    }
  },

  SOCKET_alineacionesCampbell(state, data) {
    const id = data.ID_INCENDIO
    if (!state.incendioById[id]) return
    const inc = { ...state.incendioById[id] }
    const i = (inc.ALINEACIONES_CAMPBELL || []).findIndex(a => a.ID_ALINEACIONES_CAMPBELL?.equalsIgnoreCase?.(data.ID_ALINEACIONES_CAMPBELL))
    if (i !== -1) {
      inc.ALINEACIONES_CAMPBELL = [...inc.ALINEACIONES_CAMPBELL]
      inc.ALINEACIONES_CAMPBELL[i] = { ...inc.ALINEACIONES_CAMPBELL[i], GRAFICOS_CAMPBELL: data.GRAFICOS }
    } else {
      inc.ALINEACIONES_CAMPBELL = [
        ...(inc.ALINEACIONES_CAMPBELL || []),
        {
          ID_ALINEACIONES_CAMPBELL: data.ID_ALINEACIONES_CAMPBELL,
          ID_INCENDIO: data.ID_INCENDIO,
          FECHA: data.FECHA,
          GRAFICOS_CAMPBELL: data.GRAFICOS
        }
      ]
    }
    state.incendioById = { ...state.incendioById, [id]: inc }
    this.notify('Alineación de Campbell actualizada', `Se han modificado las alineaciones para el incendio en ${inc.LOCALIDAD}`)
  }
}

const actions = {
  async fetchIncendiosReduced({ commit }) {
    const resp = await api.incendio.getIncendiosReduced()
    commit('SET_INCENDIOS_REDUCED', resp.data)
  },

  async fetchIncendioById({ state, commit }, id) {
    if (!id) return null
    if (state.incendioById[id]) return state.incendioById[id]

    const deferred = Q.defer()
    try {
      commit('SET_INCENDIO_LOADING', { id, value: true })
      const resp = await api.incendio.getIncendioById(id)
      commit('SET_INCENDIO_BY_ID', resp.data)
      deferred.resolve(resp.data)
    } catch (err) {
      console.error('[fetchIncendioById] error', err)
      deferred.reject(err)
    } finally {
      commit('SET_INCENDIO_LOADING', { id, value: false })
    }
    return deferred.promise
  },

  setFiltro({ commit }, data) {
    const d = Q.defer()
    try {
      commit('SET_FILTRO', data)
      d.resolve()
    } catch (e) {
      console.error(e)
      d.reject(e)
    }
    return d.promise
  },

  async fetchTiposIncendioNivel({ commit }) {
    const d = Q.defer()
    try {
      const r = await api.incendio.getTiposIncendioNivel()
      commit('SET_TIPOS_INCENDIO_NIVEL', r.data)
      d.resolve()
    } catch (e) {
      console.error(e)
      d.reject(e)
    }
    return d.promise
  },

  async fetchTiposIncendioEstado({ commit }) {
    const d = Q.defer()
    try {
      const r = await api.incendio.getTiposIncendioEstado()
      commit('SET_TIPOS_INCENDIO_ESTADO', r.data)
      d.resolve()
    } catch (e) {
      console.error(e)
      d.reject(e)
    }
    return d.promise
  },

  async fetchTiposDeteccion({ commit }) {
    const d = Q.defer()
    try {
      const r = await api.incendio.getTiposDeteccion()
      commit('SET_TIPOS_DETECCION', r.data)
      d.resolve()
    } catch (e) {
      console.error(e)
      d.reject(e)
    }
    return d.promise
  },

  async addIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.addIncendio(data)
      if (r.status === 200) { commit('SOCKET_addIncendio', data); socket.emit('addIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editIncendio(data)
      if (r.status === 200) { commit('SOCKET_changeIncendio', data); socket.emit('changeIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async ocultarIncendio({ commit, dispatch }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.ocultarIncendio(data)
      if (r.status === 200) {
        commit('OCULTAR_INCENDIO', data)
        if (data.OCULTO === false) await dispatch('fetchIncendiosReduced')
      }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async addNivelIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.addNivelIncendio(data)
      if (r.status === 200) { commit('SOCKET_addNivelIncendio', data); socket.emit('addNivelIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editNivelIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editNivelIncendio(data.dataEstado)
      if (r.status === 200) { commit('SOCKET_editNivelIncendio', data); socket.emit('editNivelIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async addEstadoIncendio({ commit }, data) {
    try {
      await api.incendio.addEstadoIncendio(data)
    } catch (e) { console.error(e) }
  },

  async editEstadoIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editEstadoIncendio(data)
      if (r.status === 200) { commit('SOCKET_editEstadoIncendio', data); socket.emit('editEstadoIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async deleteNivelIncendio({ commit }, data) {
    try {
      await api.incendio.deleteNivelIncendio(data)
    } catch (e) {
      console.error(e)
    }
  },

  async deleteEstadoIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.deleteEstadoIncendio(data)
      if (r.status === 200) { commit('SOCKET_deleteEstadoIncendio', data); socket.emit('deleteEstadoIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async changeSectoresIncendio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.changeSectoresIncendio(data)
      if (r.status === 200) { commit('SOCKET_changeSectoresIncendio', data); socket.emit('changeSectoresIncendio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async addMediosIncendio({ commit }, data) {
    try {
      const r = await api.incendio.addMediosIncendio(data.MEDIOS)
      if (r.status === HTTP_STATUS.OK) { commit('SOCKET_addMediosIncendio', data); socket.emit('addMediosIncendio', data) }
      if (r.status === HTTP_STATUS.NO_CONTENT) this._vm.$notify({ title: 'Solapamiento', text: 'El medio ya tiene una planificación activa que solapa con la nueva.', type: 'warning' })
    } catch (e) { console.error(e) }
  },

  async addMediosPlanificacionIncendio(_, data) {
    const d = Q.defer()
    try { await api.planificacion.addMediosAereos(data); d.resolve() } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editMediosPlanificacionIncendio(_, data) {
    const d = Q.defer()
    try { await api.planificacion.editMediosAereosPlanif(data); d.resolve() } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editMedioIncendio({ state, commit, dispatch }, data) {
    const d = Q.defer()
    try {
      if (!state.incendioById[data.ID_INCENDIO]) await dispatch('fetchIncendioById', data.ID_INCENDIO)

      const r = await api.incendio.editMedioIncendio(data)
      if (r.status === 200) {
        let estado = 24
        if (data.FECHA_FINALIZADO) estado = 19
        else if (data.FECHA_EN_LUGAR) estado = 1
        else if (data.FECHA_EN_CAMINO) estado = 7
        data.ESTADO = estado

        commit('SOCKET_editMedioIncendio', data)
        socket.emit('editMedioIncendio', data)

        const inc = state.incendioById[data.ID_INCENDIO]
        let mediosActuando = false
        for (const sector of inc?.SECTORES || []) {
          for (const medioSector of sector.MEDIOS || []) {
            if (medioSector.FECHA_EN_CAMINO && !medioSector.FECHA_EN_LUGAR) { mediosActuando = true; break }
          }
          if (mediosActuando) break
        }

        const estados = inc?.ESTADOS || []
        const actual = estados[0]?.TIPO_INCENDIO_ESTADO?.VALUE
        const INICIO = state.tiposIncendioEstado?.[0]?.VALUE
        const EXTINCION = state.tiposIncendioEstado?.[1]?.VALUE

        if (actual === INICIO) {
          if (!mediosActuando && estado === 1) {
            const nuevo = {
              ID_INCENDIO_ESTADO: UUIDService.createUUID(),
              ID_INCENDIO: inc.ID_INCENDIO,
              ID_TIPO_INCENDIO_ESTADO: state.tiposIncendioEstado[1].ID_TIPO_INCENDIO_ESTADO,
              FECHA: DateService.now(),
              TIPO_INCENDIO_ESTADO: state.tiposIncendioEstado[1]
            }
            await dispatch('addEstadoIncendio', nuevo)
          }
        } else if (actual === EXTINCION) {
          if (!mediosActuando && estados.length > 1) {
            const payload = {
              ID_INCENDIO_ESTADO: estados[0].ID_INCENDIO_ESTADO,
              ID_INCENDIO: estados[0].ID_INCENDIO,
              NUEVO_ESTADO: estados[1].TIPO_INCENDIO_ESTADO.INCENDIO_ESTADO
            }
            await dispatch('deleteEstadoIncendio', payload)
          }
        }
      }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async deleteMedioIncendio({ state, commit, dispatch }, data) {
    const d = Q.defer()
    try {
      if (!state.incendioById[data.ID_INCENDIO]) await dispatch('fetchIncendioById', data.ID_INCENDIO)

      const r = await api.incendio.deleteMedioIncendio(data)
      if (r.status === 200) {
        data.IS_ACTUALIZAR_ESTADO = r.data.IS_ACTUALIZAR_ESTADO
        commit('SOCKET_deleteMedioIncendio', data)
        socket.emit('deleteMedioIncendio', data)

        const inc = state.incendioById[data.ID_INCENDIO]
        let mediosActuando = false
        for (const sector of inc?.SECTORES || []) {
          for (const medioSector of sector.MEDIOS || []) {
            if (medioSector.FECHA_EN_CAMINO && !medioSector.FECHA_EN_LUGAR) { mediosActuando = true; break }
          }
          if (mediosActuando) break
        }

        const estados = inc?.ESTADOS || []
        const actual = estados[0]?.TIPO_INCENDIO_ESTADO?.VALUE
        const EXTINCION = state.tiposIncendioEstado?.[1]?.VALUE

        if (actual === EXTINCION && !mediosActuando && estados.length > 1) {
          const payload = {
            ID_INCENDIO_ESTADO: estados[0].ID_INCENDIO_ESTADO,
            ID_INCENDIO: estados[0].ID_INCENDIO,
            NUEVO_ESTADO: estados[1].TIPO_INCENDIO_ESTADO.INCENDIO_ESTADO
          }
          await dispatch('deleteEstadoIncendio', payload)
        }
      }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editPlanificacionMedio({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editPlanificacionMedio(data)
      if (r.status === 200) { commit('SOCKET_editPlanificacionMedio', data); socket.emit('editPlanificacionMedio', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async addPlanOperaciones({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.addPlanOperaciones(data)
      if (r.status === 200) { commit('SOCKET_addPlanOperaciones', data); socket.emit('addPlanOperaciones', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editPlanOperaciones({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editPlanOperaciones(data)
      if (r.status === 200) { commit('SOCKET_editPlanOperaciones', data); socket.emit('editPlanOperaciones', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async deletePlanOperaciones({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.deletePlanOperaciones(data)
      if (r.status === 200) { commit('SOCKET_deletePlanOperaciones', data); socket.emit('deletePlanOperaciones', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async addPerimetro({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.addPerimetro(data)
      if (r.status === 200) { commit('SOCKET_addPerimetro', data); socket.emit('addPerimetro', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editPerimetro({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editPerimetro(data)
      if (r.status === 200) { commit('SOCKET_editPerimetro', data); socket.emit('editPerimetro', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async deletePerimetro({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.deletePerimetro(data)
      if (r.status === 200) { commit('SOCKET_deletePerimetro', data); socket.emit('deletePerimetro', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editAlineacionesCampbell({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.incendio.editAlineacionesCampbell(data)
      if (r.status === 200) { commit('SOCKET_alineacionesCampbell', data); socket.emit('editAlineacionesCampbell', data) }
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async fetchImagenesSatelite({ commit }, data) {
    const d = Q.defer()
    try {
      const r = await api.imagenSatelite.getImagenesSatelite(data)
      if (r.status === 200) commit('SET_IMAGENES_SATELITE', r.data)
      d.resolve()
    } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async editPeriodoDescanso(_, data) {
    const d = Q.defer()
    try { await api.planificacion.addPeriodoDescanso(data); d.resolve() } catch (e) { console.error(e); d.reject(e) }
    return d.promise
  },

  async peticionMediosGob(_, peticion) {
    try {
      const response = await api.mediosEstatales.peticionCompleta(peticion.idIncendio, peticion)

      if (response.status === HTTP_STATUS.OK) {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const disposition = response.headers['content-disposition']
        let fileName = `solicitud_${peticion.Municipio_incendio}_${peticion.Fecha_actual}_${peticion.Hora_actual}.pdf`

        if (disposition && disposition.includes('filename=')) {
          fileName = disposition.split('filename=')[1].replaceAll('"', '')
        }

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        link.target = '_blank'

        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    } catch (err) {
      console.error('Error en peticionMediosGob:', err)
      throw err
    }
  },

  async getPeticionEstatales(_, incendio) {
    try {
      const response = await api.mediosEstatales.obtenerUltimaSolicitud(incendio)
      return response.data
    } catch (error) {
      console.error('Peticion de medios estatales no encontrada', error)
      throw error
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
